var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.886 22.2268C3.60343 22.2268 0.942383 19.5658 0.942383 16.2832C0.942383 13.0232 3.66527 10.3369 6.91397 10.3397C6.92322 10.3398 6.93105 10.3326 6.93189 10.3234C7.43998 4.77735 12.104 0.433594 17.7826 0.433594C22.0454 0.433594 25.7365 2.88136 27.527 6.44802C27.5304 6.45489 27.538 6.45879 27.5456 6.4577C32.227 5.78729 36.6041 9.53602 36.6041 14.302C36.6041 18.4113 33.4764 21.7901 29.4717 22.1877L20.1105 22.2048V16.1436L22.2853 18.3184C22.8075 18.8406 23.6543 18.8406 24.1765 18.3184C24.6988 17.7961 24.6988 16.9494 24.1765 16.4271L20.3492 12.5998C19.4788 11.7294 18.0676 11.7294 17.1972 12.5998L13.3699 16.4271C12.8476 16.9494 12.8476 17.7961 13.3699 18.3184C13.8921 18.8406 14.7389 18.8406 15.2611 18.3184L17.4359 16.1436V22.2097L8.07472 22.2268H6.886ZM17.4359 22.2097V27.1799C17.4359 27.9184 18.0346 28.5172 18.7732 28.5172C19.5118 28.5172 20.1105 27.9184 20.1105 27.1799V22.2048L17.4359 22.2097Z",
    fill: "#31B7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8040420f2ea18f4f968097e037b6354e.svg";
export { ForwardRef as ReactComponent };